import React, { Component } from 'react';
import { FloatingLabel, Form, Button, Alert } from 'react-bootstrap';
import DBService from '../../service/DBService';
import { getCookie } from '../../service/Cookie';
import { Link } from 'react-router-dom';

class UserSettings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userId: '',
      password: '',
      confirmPassword: '',
      name: '',
      phone: '',
      result: '',
      error: ''
    };
  }

  componentDidMount() {
    let cookieValue = getCookie();
    console.log('Header Cookie', cookieValue);
    if (cookieValue !== undefined && cookieValue.userId !== undefined && cookieValue.password !== undefined) {
        console.log('Cookie found', cookieValue);
        this.setState({
          userId: cookieValue.userId,
          password: cookieValue.password,
          emailId: cookieValue.emailId,
          phone: cookieValue.phone,
          name: cookieValue.name
        });
    } 
  }

  updateUser = () => {
    if (this.validate() === 0) {
      let body = {
        'userId': this.state.userId,
        'password': this.state.password,
        'name': this.state.name,
        'emailId': this.state.userId,
        'phone': this.state.phone,
        'isEmailVerified': 'Yes'
      }
      this.setState({ error: '', result: '' });
      DBService.userUpdate(body)
        .then(result => {
          console.log('User Update', result);
          if (result !== undefined && result.length !== undefined && result.length <= 0) {
            this.setState({ error: 'Error updating information, please try again.' });
          } else {
            this.setState({ result: 'Your information has been updated' });
          }
        })
        .catch((error) => {
          console.log(error);
          this.setState({ error: 'Error updating information, please try again' });
        });
    }

  }

  validate = () => {
    let errorCount = 0, error = '';

    if (this.state.name !== '') {
      if (!/^[a-zA-Z][a-zA-Z0-9 ]+$/.test(this.state.name)) {
        errorCount++;
        error = 'Invalid First and Last name (Example Valid Name: John Smith)';
        this.setState({ 'error': error });
        return errorCount;
      }
    }

    if (!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.state.userId)) {
      errorCount++;
      error = 'Invalid Email address (Example Email: abc@example.com)';
      this.setState({ 'error': error });
      return errorCount;
    }

    if (this.state.phone !== '') {
      if (!/^\d{10}$/.test(this.state.phone)) {
        errorCount++;
        error = 'Invalid Phone (Example Phone: 1234567890)';
        this.setState({ 'error': error });
        return errorCount;
      }
    }

    if (this.state.password.length < 8) {
      errorCount++;
      error = "Password should be minimum 8 characters (Example: uerY12#3)";
      this.setState({ 'error': error });
      return errorCount;
    }

    if (this.state.password !== this.state.confirmPassword) {
      errorCount++;
      error = "Confirm Password doesn't match";
      this.setState({ 'error': error });
      return errorCount;
    }

    this.setState({ 'error': error });
    return errorCount;
  }

  render() {
    return (
      <>
        <h4>VIZFM - User Settings</h4>
        <FloatingLabel
          controlId="floatingInput"
          label="Name"
          key="name"
          className="mb-3"
        >
          <Form.Control type="name" placeholder="First and Last Name" value={this.state.name} onChange={e => this.setState({ name: e.target.value })} />
        </FloatingLabel>

        <FloatingLabel
          controlId="floatingInput"
          label="Email address"
          key="email"
          className="mb-3"
        >
          <Form.Control disabled required type="email" placeholder="name@example.com" value={this.state.userId} onChange={e => this.setState({ userId: e.target.value })} />
        </FloatingLabel>

        <FloatingLabel
          controlId="floatingInput"
          label="Phone"
          key="phone"
          className="mb-3"
        >
          <Form.Control type="phone" placeholder="Phone Number" value={this.state.phone} onChange={e => this.setState({ phone: e.target.value })} />
        </FloatingLabel>

        <FloatingLabel controlId="floatingPassword" label="Password" className="mb-3" key="password">
          <Form.Control required type="password" placeholder="Password" key="password1" value={this.state.password} onChange={e => this.setState({ password: e.target.value })} />
        </FloatingLabel>

        <FloatingLabel controlId="floatingPassword" label="Confirm Password" className="mb-3" key="confirmPassword">
          <Form.Control required type="password" placeholder="Confirm Password" key="confirmPassword1" value={this.state.confirmPassword} onChange={e => this.setState({ confirmPassword: e.target.value })} />
        </FloatingLabel>
        {(this.state.result !== '') ? (
          <Alert key='primary' variant='success'>
            {this.state.result}
          </Alert>
        ) : <></>}
        {(this.state.error !== '') ? (
          <Alert key='danger' variant='danger'>
            {this.state.error}
          </Alert>

        ) : <></>}
        <p></p>
        <Button variant="primary" onClick={this.updateUser}>Update</Button>{' '}

        <p></p>
        <Link className="nav-link" to={'/signin'}>Please Signin again if you change password</Link>
      </>
    )
  }
}

export default UserSettings;